module.exports = __webpack_public_path__ + "img/rightArrow.e752e932.png";